import React from 'react';
import Header from './Header';
import Footer from './Footer';
import StickyCTA from '../cro/StickyCTA';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      {/* pt accounts for fixed header (banner ~40px + nav ~64px) */}
      <main className="flex-grow pt-24 md:pt-28">
        {children}
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
};

export default Layout;